document.addEventListener("DOMContentLoaded", async () => {
    // --- accordion ---
    if (document.querySelector(".accordion")) {
        const { initAccordion } = await import("./components/accordion.js");
        initAccordion();
    }
});
